import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-responsive";
import { isValidArray } from "../../../Layout/Common/common";
import { Link, useNavigate } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { axiosInstance } from "../../../axios/axiosInstance";
import { useAuth } from "../../../Context/AuthContext";

export const CompanyUserTable = ({ data, DeleteFun }) => {
  const tableRef = useRef(null);
  const dtRef = useRef(null);
  const { showDialogAlert, hideNoteAlert, showNoteAlert } = useNoteAlert();
  const { isAuthenticated, userId, companyId, setUser, setAthuLoading, emailAddress, role } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const $table = $(tableRef.current);
    function markFirstVisible() {
      $table.find("tbody tr").each(function () {
        const $cells = $(this).children("td").removeClass("orderCustomClass");
        const $firstVisible = $cells
          .filter(function () {
            const $td = $(this);
            return $td.is(":visible") && !$td.hasClass("dtr-hidden");
          })
          .first();
        $firstVisible.addClass("orderCustomClass");
      });
    }

    dtRef.current = $table.DataTable({
      data: [],
      columns: [
        {
          data: null,
          render: (data, type, row, meta) => meta.row + 1, // S.No
          orderable: false,
        },
        { data: "CONTACT", defaultContent: "" },
        { data: "LOGIN_NAME", defaultContent: "" },
        { data: "EMAILADDR", defaultContent: "" },
        { data: "USER_ROLE", defaultContent: "" },

        {
          data: null,
          orderable: false,
          render: (value, type, row) => {
            const userRoleId = row.USER_ROLE;
            // Always show Edit
            let html = `
      <div class="orders-button">
        <a href="javascript:void(0)" data-order-id="${row.USER_ID}" class="pendingOrder-edit js-Edit-Details">
          <span class="wes-user-edit"></span> Edit
        </a>`;

            // Show Delete only if userRoleId ≠ 1
            if (userRoleId != "Admin") {
              html += `
        <div class="button-effect pendingOrder-trash">
          <button type="button" class="btn js-delete-order" data-order-id="${row.USER_ID}">
            <span class="wes-trash"></span>
            <span class="action-menus">Delete</span>
          </button>
        </div>`;
            }

            html += `</div>`;
            return html;
          },
        },
      ],
      language: {
        paginate: {
          previous: '<i class="fa fa-chevron-left"></i>',
          next: '<i class="fa fa-chevron-right"></i>',
        },
      },
      responsive: { details: { type: "column", target: "tr" } },
      autoWidth: false,
      searching: false,
      columnDefs: [
        { targets: [5], orderable: false },
        { targets: [2, 3], className: "orderListing", responsivePriority: 3 },
      ],
      drawCallback: () => markFirstVisible(),
    });
    $table.on("responsive-resize.dt", () => markFirstVisible());
    markFirstVisible();
    $table.on("click", ".js-Edit-Details", function () {
      const USER_ID = $(this).data("order-id");
      navigate(`/myaccount/company-users-editusers/${USER_ID}`);
    });

    $table.on("click", ".js-delete-order", async function () {
      const Userid = $(this).data("order-id");

      handleDeleteClick(String(Userid));
    });

    // ✅ Scroll to top on page change
    $table.on("page.dt", function () {
      $("html, body").animate({ scrollTop: 0 }, 300);
    });
    return () => {
      dtRef.current?.destroy(true);
      dtRef.current = null;
    };
  }, []);

  useEffect(() => {
    const dt = dtRef.current;
    if (!dt) return;
    dt.clear();
    if (Array.isArray(data) && data.length) dt.rows.add(data);
    dt.draw(true);
  }, [data]);
  function gotoEditPage(userId) {
    navigate(`/myaccount/company-users-editusers/${userId}`);
  }
  const handleDeleteClick = (Userid) => {
    showDialogAlert({
      content: "Do you want to delete this order permanently?",
      title: "Delete Confirmation",
      primaryBtn: {
        caption: "Yes, Remove",
        onClick: () => userDeletefun(Userid),
      },
      scondaryBtn: { caption: "Cancel", onClick: hideNoteAlert },
    });
  };
  const renderTable = (raw) => {
    const dt = dtRef.current;
    if (!dt) return;
    dt.clear();
    if (Array.isArray(raw)) dt.rows.add(raw);
    dt.draw(true);
  };

  const userDeletefun = async (Userid) => {
    var data = {
      UserId: parseInt(Userid, 10),
    };
    axiosInstance
      .post("CompanyUsers/DeleteClick", data)
      .then((response) => {

        if (response.data != null) {
          hideNoteAlert();
          DeleteFun();
        } else {
          showNoteAlert("User Not Delete. Please Try Again");
        }
      })
      .catch((error) => console.log(error.message));
  };

  return (
    <table ref={tableRef} className="table table-striped display nowrap orderlist-table" style={{ width: "100%" }}>
      <thead>
        <tr>
          <th>S No</th>
          <th>User Name</th>
          <th>Login</th>
          <th>Email</th>
          <th>Account Type</th>
          <th></th>
        </tr>
      </thead>
      <tbody />
    </table>
  );
};
